<template>
  <div class="middle-left-2">
    <div class="middle-left-2-1 logout" v-if="!isLogin">
      <a href="/login">{{$t('global.登录')}}</a>{{$t('global.或')}}
      <a href="/reg">{{$t('global.注册')}}</a>，{{$t('global.说说你的看法')}}
    </div>
    <div class="middle-left-2-1 login" v-if="isLogin">
      <div class="typearea">
        <textarea :placeholder="`${$t('global.留点足迹')}...`" v-model="commentContent"></textarea>
        <span class="typecount">{{5000-commentContent.length}}</span>
      </div>
      <button class="comment-btn" @click="SubmitComment()">{{$t('global.评论')}}</button>
    </div>
    <div class="middle-left-2-2">
      <div class="sum">
        {{$t('global.全部评论')}}：
        <span>{{activityItem.commentCount}}</span>
      </div>
      <div class="comment-list">
        <div class="comment-item" v-for="(item, index) in commentList" :key="index">
          <div class="comment-item-content">
            <img class="comment-avatar" :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)" />
            <div class="comment-middle">
              <div class="comment-middle-1">
                <span class="comment-name">{{item.nickName}}</span>
                <span class="comment-time">{{item.date}}</span>
              </div>
              <div class="comment-middle-2">{{item.body}}</div>
            </div>
            <div class="comment-right">
              <div class="comment-count">
                <span class="comment-count-icon" v-on:click="showReply(item.id)"></span>
                {{item.replyCount}}
              </div>
              <div class="ding-count" :class="{'ding-count-icon-active': (item.isLike == 1)}">
                <span class="iconfont ding-count-icon" @click="commentLike(item)">&#xe713;</span>
                {{item.likeCount}}
              </div>
            </div>
            <a class="report commentReport" @click="showReportC(item.id)">
              <span class="link-icon link-icon-jubao"></span>{{$t('global.举报')}}
            </a>
          </div>
          <div
            class="comment-reply"
            v-if="showReplyId==item.id && item.userCommentReplyResponseList"
          >
            <div class="comment-reply-list">
              <div
                class="comment-reply-item"
                v-for="(subitem, index) in item.userCommentReplyResponseList"
                :key="index"
              >
                <div class="comment-reply-middle-1">
                  <span class="comment-name">{{subitem.nickName}}</span>
                  <span class="comment-time">{{subitem.date}}</span>
                </div>
                <div class="comment-middle-2">{{subitem.body}}</div>
              </div>
            </div>
          </div>
          <div class="comment-reply-form" v-if="showReplyId==item.id && isLogin">
            <div class="typearea">
              <textarea :placeholder="$t('global.请输入回复内容')" v-model="replyContent"></textarea>
              <span class="typecount">{{5000-replyContent.length}}</span>
            </div>
            <div class="reply-btns">
              <button class="reply-btn-cancel">{{$t('global.取消')}}</button>
              <button class="reply-btn-yes" @click="SubmitReplyComment()">{{$t('global.回复')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="comment-more"
      @click="getMoreComment()"
      v-if="commentTotalPage>commentPageIndex"
    >{{$t('global.查看更多')}}</div>
    <el-dialog :visible.sync="reportVisible" width="22%">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item :label="`${$t('global.请填写举报理由')}：`">
          <el-checkbox-group v-model="form.reason">
            <el-checkbox :label="$t('global.涉及黄赌毒和暴力')" name="reason"></el-checkbox>
            <el-checkbox :label="$t('global.政治')" name="reason"></el-checkbox>
            <el-checkbox :label="$t('global.版权问题')" name="reason"></el-checkbox>
            <el-checkbox :label="$t('global.抄袭')" name="reason"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            v-model="form.content"
            wrap="hard"
            :placeholder="$t('global.请输入举报内容，我们将尽快处理。')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{$t('global.提交')}}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="message">{{$t('global.也可发邮件给我们')}}：info@manamana.net</p>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import joinDialog from "@/components/JoinDialog.vue";

export default {
  name: "comment",
  components: {
    MainLayout,
    service,
    joinDialog
  },

  data() {
    return {
      isLogin: true,
      commentContent: "",
      replyContent: "",
      showReplyId: 0,
      activityItem: {},
      commentPageIndex: 1,
      commentPageSize: 6,
      commentList: [],
      commentTotalPage: 1,
      reportVisible: false,
      form: {
        reason: [],
        content: ""
      }
    };
  },

  methods: {
    showReportC(id) {
      this.reportVisible = true;
      this.reportType = 2;
      this.reportId = id;
    },
    onSubmit() {
      var $this = this;
      this.$http
        .post(
          "/api/u/report/?reason=" +
            this.form.reason.toString() +
            "&content=" +
            this.form.content +
            "&domainId=" +
            this.reportId +
            "&type=" +
            this.reportType
        )
        .then(function(response) {
          if (response) {
            $this.$message.success($this.$t('global.提交成功'));
            setTimeout(() => {
              $this.reportVisible = false;
            }, 2000);
          }
        });
    },
    showReply(id) {
      if (this.showReplyId == id) {
        this.showReplyId = 0;
      } else {
        this.showReplyId = id;
      }
    },
    getCommentList() {
      var $this = this;
      this.$http
        .get("/api/activity/commentList", {
          params: {
            activityId: this.$route.params.id,
            pageIndex: this.commentPageIndex,
            pageSize: this.commentPageSize
          }
        })
        .then(function(response) {
          if (response.data) {
            $this.commentList = $this.commentList.concat(
              response.data.userCommentResponsePageList.list
            );
            $this.commentTotalPage = response.data.totalPage;
          }
        });
    },
    getMoreComment() {
      this.commentPageIndex++;
      this.getCommentList();
    },
    commentLike(item) {
      let $this = this;
      let result = item.isLike === 2;
      $this.$http
        .post("/api/u/relation/comment/" + item.id, { domainType: 6, type: 3 })
        .then(response => {
          if (response) {
            if (result) {
              item.likeCount++;
              item.isLike = 1;
              $this.$message.success(this.$t('global.点赞成功'));
            } else {
              item.likeCount--;
              item.isLike = 2;
              $this.$message(this.$t('global.取消点赞成功'));
            }
          }
        });
    },
    SubmitComment() {
      var $this = this;
      if (!this.commentContent) {
        $this.$message.error(this.$t('global.回复内容不能为空'));
        return false;
      }
      this.$http
        .post("/api/u/comment/createComment", {
          domainId: this.$route.params.id,
          type: 3,
          content: this.commentContent
        })
        .then(function(response) {
          if (response) {
            $this.commentContent = "";
            $this.$message(response.message);
          }
        });
    },
    SubmitReplyComment() {
      var $this = this;
      if (!this.replyContent) {
        $this.$message.error(this.$t('global.回复内容不能为空'));
        return false;
      }
      this.$http
        .post("/api/u/comment/createReply", {
          commentId: this.showReplyId,
          content: this.replyContent
        })
        .then(function(response) {
          if (response) {
            $this.replyContent = "";
            $this.$message(response.message);
          }
        });
    }
  },

  created() {
    var $this = this;
    this.isLogin = localStorage.getItem("auth_token");
    this.getCommentList();
  }
};
</script>

<style lang="stylus" scoped>
.report:hover {
  cursor: pointer;
}

.el-dialog__body {
  padding: 0 0.6rem;
  padding-bottom: 0.2rem;
}

.el-dialog {
  border-radius: 0.3rem;
}

.el-form-item__label {
  font-size: 0.2rem;
}

.el-checkbox {
  display: block;
  margin-left: 0 !important;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-form-item {
  margin-bottom: 0;
}

.el-textarea__inner {
  height: 1.4rem;
  border-radius: 0.1rem;
  padding: 0.12rem 0.3rem;
  margin-top: 0.1rem;
}

.el-button {
  width: 1.3rem;
  height: 0.4rem;
  border-radius: 0.3rem;
  line-height: 0.4rem;
  padding: 0;
  margin-top: 0.3rem;
}

.message {
  margin-top: 0.1rem;
  color: #c2c2c2;
}

.middle-left-2 {
  -webkit-border-radius: 0.06rem;
  -moz-border-radius: 0.06rem;
  border-radius: 0.06rem;
  background-color: #fff;
  min-height: 1px;
  overflow: hidden;
  zoom: 1;
  padding: 0.4rem 0.6rem 0.45rem;
  margin-top: 0.2rem;
  padding-bottom: 0.1rem;
}

.middle-left-2-1 {
  height: 2.9rem;
  color: #000;
  font-size: 0.2rem;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
  margin: 0 -0.6rem;
  overflow: hidden;
  zoom: 1;
}

.middle-left-2-1 a {
  color: #0060ff;
  text-decoration: underline #0060ff;
}

.middle-left-2-1.logout {
  text-align: center;
  padding-top: 1.38rem;
}

.middle-left-2-1.login .typearea {
  margin: 0 0.6rem;
  position: relative;
}

.middle-left-2-1.login .typearea textarea {
  height: 1.6rem;
  border: 1px solid #eeeeee;
  outline: none;
  background-color: #f9f9f9;
  font-size: 0.14rem;
  color: #999999;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.18rem;
  resize: none;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.middle-left-2-1.login .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
}

.middle-left-2-1.logout {
  text-align: center;
  padding-top: 1.38rem;
}

.comment-reply-form .typearea {
  position: relative;
}

.comment-reply-form .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
}

.comment-btn {
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.42rem;
  border: 0.02rem solid #0161ff;
  font-size: 0.18rem;
  color: #0161ff;
  text-align: center;
  background-color: #fff;
  -webkit-border-radius: 0.21rem;
  -moz-border-radius: 0.21rem;
  border-radius: 0.23rem;
  float: right;
  margin-right: 0.6rem;
  margin-top: 0.24rem;
}

.commentReport {
  position: absolute;
  right: 0;
}

.link-icon {
  display: inline-block;
  margin-right: 0.1rem;
  vertical-align: middle;
}

.link-icon.link-icon-jubao {
  background: url('/static/vedio/jubao.png') no-repeat center center;
  background-size: contain;
  width: 0.22rem;
  height: 0.22rem;
  cursor: pointer;
}

.middle-left-2-2 {
  padding-top: 0.18rem;
}

.middle-left-2-2 .sum {
  font-size: 0.18rem;
  color: #777;
}

.middle-left-2-2 .sum span {
  font-size: 0.22rem;
  color: #333;
}

.comment-item {
  padding: 0.4rem 0;
  border-bottom: 1px solid #eeeeee;
  clear: both;
}

.comment-item-content {
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.comment-avatar {
  width: 0.5rem;
  height: 0.5rem;
  float: left;
  border-radius: 0.25rem;
}

.comment-middle {
  margin-left: 0.18rem;
  float: left;
  // width: 8.5rem;
  overflow: hidden;
  zoom: 1;
}

.comment-name {
  font-size: 0.18rem;
  color: #333;
  vertical-align: bottom;
  font-weight: bold;
  display: inline-block;
}

.comment-time {
  font-size: 0.16rem;
  color: #999;
  vertical-align: bottom;
}

.comment-middle-2 {
  font-size: 0.16rem;
  color: #777;
  margin-top: 0.15rem;
  line-height: 0.26rem;
}

.comment-right {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.16rem;
  color: #777;
}

.comment-count, .ding-count {
  display: inline-block;
}

.comment-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  background: url('/static/vedio/comment.png') no-repeat center center;
  background-size: contain;
  margin-right: 0.1rem;
  vertical-align: top;
  cursor: pointer;
}

.ding-count-icon {
  display: inline-block;
  width: 0.18rem;
  height: 0.18rem;
  margin: -0.03rem 0.1rem 0 0.2rem;
  vertical-align: top;
  cursor: pointer;
  font-size: 0.22rem;
}

.ding-count-icon-active {
  color: #0060ff;
}

.comment-reply {
  clear: both;
  margin-left: 0.68rem;
  margin-top: 0.25rem;
  background-color: #f9f9f9;
  border: 1px solid #eeeeee;
  position: relative;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0.22rem 0.19rem;
}

.comment-reply:before {
  content: '';
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #eeeeee;
  top: -0.13rem;
  left: 0.43rem;
}

.comment-reply:after {
  content: '';
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 0.105rem solid transparent;
  border-left: 0.105rem solid transparent;
  border-top: none;
  border-bottom: 0.13rem solid #f9f9f9;
  top: -0.11rem;
  left: 0.43rem;
}

.comment-reply-form {
  margin-top: 0.2rem;
  padding-left: 0.68rem;
  position: relative;
}

.comment-reply-form textarea {
  border: 1px solid #eeeeee;
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0.19rem 0.2rem;
  font-size: 0.16rem;
  color: #777;
  resize: none;
  outline: none;
  height: 1.6rem;
}

.comment-reply-form .typearea {
  position: relative;
}

.comment-reply-form .typearea .typecount {
  position: absolute;
  font-size: 0.14rem;
  color: #999999;
  right: 0.2rem;
  bottom: 0.12rem;
}

.reply-btns {
  text-align: right;
  margin-top: 0.24rem;
}

.reply-btns button {
  width: 1.52rem;
  height: 0.46rem;
  line-height: 0.46rem;
  text-align: center;
  padding: 0;
  -webkit-border-radius: 0.23rem;
  -moz-border-radius: 0.23rem;
  border-radius: 0.23rem;
  border: 0.02rem solid;
  background-color: #fff;
  font-size: 0.18rem;
}

.reply-btns .reply-btn-cancel {
  border-color: #777777;
  color: #777777;
  margin-right: 0.2rem;
}

.reply-btn-yes {
  border-color: #0161ff;
  color: #0161ff;
}

.comment-more {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.18rem;
  color: #0161ff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/activity/Comments.vue